(function () {
  let productCache = {};
  let isSwapping = false;

  // Preload product section
  function preloadProduct(handle, sectionId) {
    if (productCache[handle]) return;

    fetch(`/products/${handle}?section_id=${sectionId}`)
      .then(res => res.text())
      .then(html => {
        productCache[handle] = html;
      })
      .catch(() => {});
  }

    function reloadTrustpilotWidgets(scope = document) {
      if (!window.Trustpilot || !window.Trustpilot.loadFromElement) return;

      const widgets = scope.querySelectorAll('.trustpilot-widget');

      widgets.forEach(widget => {
        window.Trustpilot.loadFromElement(widget, true);
      });
    }

    function reinitProductGallery(scope) {
      const slideshows = scope.querySelectorAll('.product-slideshow');


      slideshows.forEach(slideshow => {
        const $main = jQuery(slideshow);

        // Find the thumbnails inside the same section
        const section = slideshow.closest('[id^="shopify-section-"]');
        const $thumbs = section ? jQuery(section).find('.thumbnails') : null;

        // Destroy slick if already initialized
        if ($main.hasClass('slick-initialized')) $main.slick('unslick');
        if ($thumbs && $thumbs.hasClass('slick-initialized')) $thumbs.slick('unslick');

        // Remove leftover slick classes
        slideshow.classList.remove('slick-initialized', 'slick-slider', 'slick-dotted');
        if ($thumbs) $thumbs.removeClass('slick-initialized slick-slider slick-dotted');

        // Re-init main slider
        const mainSettings = {
          adaptiveHeight: true,
          initialSlide: 0,
          dots: true,
          arrows: true,
        };

        if ($thumbs && $thumbs.length) {
          mainSettings.asNavFor = $thumbs;
        }

        $main.slick(mainSettings);

        // Re-init thumbnails if exist
        if ($thumbs && $thumbs.length) {
          $thumbs.slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            asNavFor: $main,
            dots: false,
            arrows: true,
            focusOnSelect: true,
            infinite: false,
            responsive: [
              { breakpoint: 768, settings: { slidesToShow: 3 } },
              { breakpoint: 480, settings: { slidesToShow: 2 } }
            ]
          });
        }
      });
      
    }

    function reinitProductGalleryThumbs(scope) {
      const thumbs = scope.querySelectorAll('.thumbnails a.thumbnail');
      thumbs.forEach(thumb => {
        thumb.addEventListener('click', function(e){
            e.preventDefault();
        });
      })
    }




  // Swap main product section
  function swapSection(html, sectionId, handle) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");

    const newSection = doc.querySelector(`#shopify-section-${sectionId}`);
    const currentSection = document.querySelector(`#shopify-section-${sectionId}`);
    if (!newSection || !currentSection) return;

    // Replace the section node (preserves theme JS lifecycle better)
    currentSection.replaceWith(newSection);

    // Force complete Symmetry animations
    const animatedEls = newSection.querySelectorAll('[data-cc-animate]');
    animatedEls.forEach(el => {
      el.classList.add('cc-animate-init', '-in', 'cc-animate-complete');
      el.style.opacity = '1';
    });

    // Update URL
    window.history.replaceState({}, "", `/products/${handle}`);

    // Trigger global reload event if any scripts listen
    document.dispatchEvent(new CustomEvent("theme:section:reload"));
      initUspAccordion();
      reloadTrustpilotWidgets(document);
      // Reinit product gallery and thumbs
      reinitProductGallery(newSection);
      reinitProductGalleryThumbs(document);
  }

  // Swap secondary buy button section
  function swapSecondaryBtn(handle) {
    const wrapper = document.getElementById('secondary-buy-btn-wrapper');
    if (!wrapper) return;

    const sectionId = wrapper.dataset.sectionId;
    if (!sectionId) return;

    fetch(`/products/${handle}?section_id=${sectionId}`)
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const newSection = doc.querySelector(`#shopify-section-${sectionId}`);
        if (newSection) wrapper.innerHTML = newSection.innerHTML;
      })
      .catch(err => console.error('Failed to reload secondary buy button', err));
  }

  // Click listener for variant buttons
  document.addEventListener("click", async function (e) {
    const button = e.target.closest(".variant-item");
    if (!button || isSwapping) return;

    const wrapper = button.closest(".cross-product-variants");
    if (!wrapper) return;

    const handle = button.dataset.handle;
    const sectionId = wrapper.dataset.sectionId;

    if (!handle || !sectionId) return;

    // Prevent self-click reload
    if (button.classList.contains('is-active')) return;

    // Active class switching
    const currentActive = wrapper.querySelector(".is-active");
    if (currentActive) currentActive.classList.remove("is-active");
    button.classList.add("is-active");

    isSwapping = true;

    try {
      let html;

      if (productCache[handle]) {
        html = productCache[handle];
      } else {
        const response = await fetch(`/products/${handle}?section_id=${sectionId}`);
        html = await response.text();
        productCache[handle] = html;
      }

      // Swap main product section
      swapSection(html, sectionId, handle);

      // Swap secondary buy button section
      swapSecondaryBtn(handle);

    } catch (error) {
      console.error("Product swap failed", error);
    }

    isSwapping = false;
  });

  // Preload all adjacent products on page load
  document.addEventListener("DOMContentLoaded", function () {
    const wrapper = document.querySelector(".cross-product-variants");
    if (!wrapper) return;

    const sectionId = wrapper.dataset.sectionId;
    const buttons = wrapper.querySelectorAll(".variant-item");

    buttons.forEach(btn => {
      const handle = btn.dataset.handle;
      if (handle) preloadProduct(handle, sectionId);
    });
  });


  // Intercept all /cart/add forms for AJAX + Rebuy SmartCart
  if (!window.__rebuyAjaxInterceptor) {
    window.__rebuyAjaxInterceptor = true;

    document.addEventListener('submit', function(e) {
      const form = e.target;

      if (form.matches('form[action="/cart/add"]')) {
        e.preventDefault();

        const formData = new FormData(form);

        fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: { 'Accept': 'application/json' }
        })
        .then(res => res.json())
        .then(data => {
          console.log('Added via AJAX:', data);

          // Show Rebuy SmartCart if loaded
          if (window.Rebuy && Rebuy.SmartCart) {
            Rebuy.SmartCart.show();
          }
        })
        .catch(err => console.error('AJAX add failed:', err));
      }
    });
  }

})();
